import { Theme } from '@mui/material/styles'

const MuiTypography = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        letterSpacing: '0.1px'
      }
    }
  }
}

export default MuiTypography
